import React, { useEffect, useState } from "react";
import { moneyFormat } from "../../util/format";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

export const Checkout = () => {
  const navigate = useNavigate();
  const [products] = useState(() => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    return cart;
  });
  const [errors, setErrors] = useState({});
  const [appliedDiscounts, setAppliedDiscounts] = useState([]);
  const [selectedDiscounts, setSelectedDiscounts] = useState([]);
  const [isValidatingDiscount, setIsValidatingDiscount] = useState(false);
  const [serverError, setServerError] = useState("");
  const [orderSummary, setOrderSummary] = useState({
    originalTotal: 0,
    discountAmount: 0,
    finalTotal: 0,
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [discountCode, setDiscountCode] = useState("");
  const fullName = localStorage.getItem("fullName");
  const email = localStorage.getItem("email");
  const numberPhone = localStorage.getItem("numberPhone");
  const address = localStorage.getItem("address");

  const [formData, setFormData] = useState({
    customerName: fullName || "",
    customerPhone: numberPhone || "",
    customerEmail: email || "",
    customerAddress: address || "",
    items: products,
    shippingMethod: "standard_shipping",
    paymentMethod: "cod",
    note: "",
    discounts: [],
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      discounts: appliedDiscounts.map((discount) => ({
        code: discount.code,
        type: discount.type,
        value: discount.value,
      })),
    }));
  }, [appliedDiscounts]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.customerName.trim()) {
      newErrors.customerName = "Vui lòng nhập họ và tên";
    }

    if (!formData.customerPhone.trim()) {
      newErrors.customerPhone = "Vui lòng nhập số điện thoại";
    } else if (!/^[0-9]{10,11}$/.test(formData.customerPhone)) {
      newErrors.customerPhone = "Số điện thoại không hợp lệ";
    }

    if (
      formData.customerEmail.trim() &&
      !/\S+@\S+\.\S+/.test(formData.customerEmail)
    ) {
      newErrors.customerEmail = "Email không hợp lệ";
    }

    if (!formData.customerAddress.trim()) {
      newErrors.customerAddress = "Vui lòng nhập địa chỉ";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const showConfirmationDialog = (action) => {
    setConfirmAction(() => action);
    setShowConfirmModal(true);
  };

  const applySelectedDiscounts = async () => {
    if (selectedDiscounts.length === 0) {
      toast.error("Vui lòng chọn ít nhất một mã giảm giá");
      return;
    }

    setIsValidatingDiscount(true);

    try {
      const response = await axios.post("/discount/apply", {
        codes: selectedDiscounts.map((d) => d.code),
        items: products,
      });

      const validationResult = response.data.data;

      if (validationResult) {
        const appliedDiscountCodes = validationResult.appliedDiscounts.map(
          (d) => d.discountCode,
        );
        const validDiscounts = selectedDiscounts.filter((d) =>
          appliedDiscountCodes.includes(d.code),
        );

        const invalidDiscounts = selectedDiscounts.filter(
          (d) => !appliedDiscountCodes.includes(d.code),
        );

        if (validDiscounts.length > 0) {
          const newDiscounts = validationResult.appliedDiscounts.map(
            (apiDiscount) => {
              const originalDiscount =
                selectedDiscounts.find(
                  (d) => d.code === apiDiscount.discountCode,
                ) || {};

              return {
                code: apiDiscount.discountCode,
                discountCode: apiDiscount.discountCode,
                id: apiDiscount.id,
                value: apiDiscount.discountAmount,
                amount: apiDiscount.discountAmount,
                type: originalDiscount.type || "fixed",
                description:
                  originalDiscount.description ||
                  `Giảm ${moneyFormat(apiDiscount.discountAmount)}`,
              };
            },
          );

          setOrderSummary({
            originalTotal: validationResult.originalTotal,
            discountAmount: validationResult.discountAmount,
            finalTotal: validationResult.finalTotal,
            discountedItems: validationResult.discountedItems,
          });

          const updatedDiscounts = [
            ...appliedDiscounts.filter(
              (d) =>
                !newDiscounts.some((nd) => nd.discountCode === d.discountCode),
            ),
            ...newDiscounts,
          ];

          setAppliedDiscounts(updatedDiscounts);
          toast.success(`Đã áp dụng ${validDiscounts.length} mã giảm giá`);

          setSelectedDiscounts(
            selectedDiscounts.filter(
              (d) => !appliedDiscountCodes.includes(d.code),
            ),
          );
        }

        if (invalidDiscounts.length > 0) {
          const invalidCodes = invalidDiscounts.map((d) => d.code).join(", ");
          toast.error(
            `Mã giảm giá ${invalidCodes} không hợp lệ hoặc không áp dụng được cho đơn hàng này`,
          );
        }
      } else {
        toast.error("Không thể áp dụng các mã giảm giá đã chọn");
      }
    } catch (error) {
      console.error("Error validating discounts:", error);
      toast.error("Lỗi khi kiểm tra mã giảm giá. Vui lòng thử lại sau.");
    } finally {
      setIsValidatingDiscount(false);
    }
  };

  const removeDiscount = async (discountToRemove) => {
    const updatedDiscounts = appliedDiscounts.filter(
      (d) =>
        d.code !== discountToRemove.code &&
        d.discountCode !== discountToRemove.discountCode,
    );

    setIsValidatingDiscount(true);

    try {
      if (updatedDiscounts.length === 0) {
        setAppliedDiscounts([]);
        setOrderSummary({
          originalTotal: totalPrice,
          discountAmount: 0,
          finalTotal: totalPrice,
        });
        toast.info(
          `Đã xóa mã giảm giá "${
            discountToRemove.code || discountToRemove.discountCode
          }"`,
        );
        setIsValidatingDiscount(false);
        return;
      }

      const response = await axios.post("/discount/apply", {
        codes: updatedDiscounts.map((d) => d.code || d.discountCode),
        items: products,
      });

      const validationResult = response.data.data;

      if (validationResult) {
        setOrderSummary({
          originalTotal: validationResult.originalTotal,
          discountAmount: validationResult.discountAmount,
          finalTotal: validationResult.finalTotal,
          discountedItems: validationResult.discountedItems,
        });

        const newDiscounts = validationResult.appliedDiscounts.map(
          (apiDiscount) => {
            const originalDiscount =
              updatedDiscounts.find(
                (d) =>
                  d.code === apiDiscount.discountCode ||
                  d.discountCode === apiDiscount.discountCode,
              ) || {};

            return {
              code: apiDiscount.discountCode,
              discountCode: apiDiscount.discountCode,
              id: apiDiscount.id,
              value: apiDiscount.discountAmount,
              amount: apiDiscount.discountAmount,
              type: originalDiscount.type || "fixed",
              description:
                originalDiscount.description ||
                `Giảm ${moneyFormat(apiDiscount.discountAmount)}`,
            };
          },
        );

        setAppliedDiscounts(newDiscounts);
        toast.info(
          `Đã xóa mã giảm giá "${
            discountToRemove.code || discountToRemove.discountCode
          }"`,
        );
      } else {
        setAppliedDiscounts(updatedDiscounts);
        toast.info(
          `Đã xóa mã giảm giá "${
            discountToRemove.code || discountToRemove.discountCode
          }"`,
        );
      }
    } catch (error) {
      console.error("Error updating discounts:", error);
      setAppliedDiscounts(updatedDiscounts);
      toast.info(
        `Đã xóa mã giảm giá "${
          discountToRemove.code || discountToRemove.discountCode
        }"`,
      );
    } finally {
      setIsValidatingDiscount(false);
    }
  };

  const removeAllDiscounts = () => {
    setAppliedDiscounts([]);
    setOrderSummary({
      originalTotal: totalPrice,
      discountAmount: 0,
      finalTotal: totalPrice,
    });
    toast.info("Đã xóa tất cả mã giảm giá");
  };

  const calculateDiscountAmount = () => {
    if (orderSummary.discountAmount > 0) {
      return orderSummary.discountAmount;
    }

    if (appliedDiscounts.length === 0) return 0;

    return appliedDiscounts.reduce((total, discount) => {
      return total + (discount.amount || discount.value || 0);
    }, 0);
  };

  const validateAllDiscountsBeforeCheckout = async () => {
    if (appliedDiscounts.length === 0) return true;

    try {
      setIsSubmitting(true);

      const response = await axios.post("/discount/apply", {
        codes: appliedDiscounts.map((d) => d.code || d.discountCode),
        items: products,
      });

      const validationResult = response.data.data;

      if (validationResult) {
        const appliedDiscountCodes = validationResult.appliedDiscounts.map(
          (d) => d.discountCode,
        );
        const invalidCodes = appliedDiscounts
          .map((d) => d.code || d.discountCode)
          .filter((code) => !appliedDiscountCodes.includes(code));

        if (invalidCodes.length > 0) {
          setAppliedDiscounts(
            appliedDiscounts.filter(
              (d) => !invalidCodes.includes(d.code || d.discountCode),
            ),
          );
          toast.warning(
            `Mã giảm giá ${invalidCodes.join(
              ", ",
            )} không hợp lệ và đã bị loại bỏ`,
          );
          return false;
        }

        const updatedDiscounts = validationResult.appliedDiscounts.map(
          (apiDiscount) => {
            const originalDiscount =
              appliedDiscounts.find(
                (d) =>
                  d.code === apiDiscount.discountCode ||
                  d.discountCode === apiDiscount.discountCode,
              ) || {};

            return {
              code: apiDiscount.discountCode,
              discountCode: apiDiscount.discountCode,
              id: apiDiscount.id,
              value: apiDiscount.discountAmount,
              amount: apiDiscount.discountAmount,
              type: originalDiscount.type || "fixed",
              description:
                originalDiscount.description ||
                `Giảm ${moneyFormat(apiDiscount.discountAmount)}`,
            };
          },
        );

        setAppliedDiscounts(updatedDiscounts);

        setOrderSummary({
          originalTotal: validationResult.originalTotal,
          discountAmount: validationResult.discountAmount,
          finalTotal: validationResult.finalTotal,
          discountedItems: validationResult.discountedItems,
        });

        return true;
      }

      return true;
    } catch (error) {
      console.error("Error validating discounts:", error);
      toast.error("Lỗi khi kiểm tra mã giảm giá. Vui lòng thử lại sau.");
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCheckout = async () => {
    setServerError("");

    if (!validateForm()) {
      toast.error("Vui lòng điền đầy đủ thông tin");
      return;
    }

    if (products.length === 0) {
      toast.error("Giỏ hàng của bạn đang trống");
      return;
    }

    if (selectedDiscounts.length > 0) {
      showConfirmationDialog(async () => {
        await applySelectedDiscounts();
        setShowConfirmModal(false);
      }, "Bạn có mã giảm giá đã chọn nhưng chưa áp dụng. Bạn có muốn áp dụng trước khi thanh toán không?");
      return;
    }

    proceedWithCheckout();
  };

  const proceedWithCheckout = async () => {
    const discountsValid = await validateAllDiscountsBeforeCheckout();
    if (!discountsValid) return;

    setIsSubmitting(true);
    const updatedFormData = {
      ...formData,
      discounts: appliedDiscounts.map((discount) => discount.code),
    };

    axios
      .post("/order/create", updatedFormData)
      .then((res) => {
        localStorage.setItem("cart", "[]");
        // Dispatch custom event to update cart count in Header
        window.dispatchEvent(new Event("cartUpdated"));
        toast.success("Đặt hàng thành công");

        navigate("/order-success", {
          state: {
            orderData: {
              ...updatedFormData,
              orderCode:
                res.data.data?.code || `DH${Date.now().toString().slice(-6)}`,
              subtotal: res.data.data?.subTotal || 0,
              discountAmount: res.data.data?.discountAmount || 0,
              shipping: 0,
              total: res.data.data?.totalAmount || 0,
            },
          },
        });
      })
      .catch((err) => {
        console.log(err);

        if (err.response) {
          const errorData = err.response.data;

          if (errorData.message) {
            setServerError(errorData.message);
            toast.error(errorData.message);
          } else if (errorData.error) {
            setServerError(errorData.error);
            toast.error(errorData.error);
          } else if (typeof errorData === "string") {
            setServerError(errorData);
            toast.error(errorData);
          } else {
            setServerError("Đã xảy ra lỗi khi đặt hàng. Vui lòng thử lại sau.");
            toast.error("Đã xảy ra lỗi khi đặt hàng. Vui lòng thử lại sau.");
          }

          if (errorData.errors) {
            const fieldErrors = {};
            Object.entries(errorData.errors).forEach(([key, value]) => {
              fieldErrors[key] = Array.isArray(value) ? value[0] : value;
            });
            setErrors(fieldErrors);
          }
        } else if (err.request) {
          setServerError(
            "Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng và thử lại.",
          );
          toast.error(
            "Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng và thử lại.",
          );
        } else {
          setServerError("Đã xảy ra lỗi khi đặt hàng. Vui lòng thử lại sau.");
          toast.error("Đã xảy ra lỗi khi đặt hàng. Vui lòng thử lại sau.");
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const totalPrice = products?.reduce(
    (sum, item) => sum + Number(item.price * item.quantity),
    0,
  );

  const discountAmount = calculateDiscountAmount();
  // const finalShippingCost = calculateShippingCost();

  const finalTotal =
    orderSummary.finalTotal > 0
      ? orderSummary.finalTotal
      : totalPrice - discountAmount;

  const ConfirmationModal = () => {
    if (!showConfirmModal) return null;

    return (
      <div className="modal-container">
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="confirmationModal"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Xác nhận</h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={() => setShowConfirmModal(false)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Bạn có mã giảm giá đã chọn nhưng chưa áp dụng. Bạn có muốn áp
                  dụng mã giảm giá trước khi thanh toán không?
                </p>
                <div className="d-flex align-items-center justify-content-start mb-2">
                  <i className="fa fa-info-circle text-primary mr-2"></i>
                  <span className="small">
                    Việc áp dụng mã giảm giá có thể giúp bạn tiết kiệm chi phí
                    đơn hàng
                  </span>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowConfirmModal(false);
                    proceedWithCheckout();
                  }}
                >
                  Không, tiếp tục thanh toán
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={confirmAction}
                >
                  Áp dụng mã giảm giá
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="col-12">
            <nav className="breadcrumb bg-light mb-30">
              <Link className="breadcrumb-item text-dark" to="/">
                Trang chủ
              </Link>
              <Link className="breadcrumb-item text-dark" to="/cart">
                Giỏ hàng
              </Link>
              <span className="breadcrumb-item active">Thanh toán</span>
            </nav>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row px-xl-5">
          {/* Left side: Thông tin nhận hàng + chi tiết đơn hàng */}
          <div className="col-lg-8">
            {serverError && (
              <div className="alert alert-danger mb-4">
                <strong>Lỗi:</strong> {serverError}
              </div>
            )}

            <h5 className="section-title position-relative text-uppercase mb-3">
              <span className="bg-secondary pr-3">Địa chỉ nhận hàng</span>
            </h5>
            <div className="bg-light p-30 mb-5">
              <div className="row">
                {[
                  { label: "Họ và tên", key: "customerName" },
                  { label: "Số điện thoại", key: "customerPhone" },
                  { label: "Email", key: "customerEmail" },
                  { label: "Địa chỉ", key: "customerAddress" },
                ].map(({ label, key }, index) => (
                  <div key={index} className="col-md-6 form-group">
                    <label>
                      {label}{" "}
                      {key !== "customerEmail" && (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    <input
                      className={`form-control ${
                        errors[key] ? "is-invalid" : ""
                      }`}
                      type="text"
                      value={formData[key]}
                      onChange={(e) => {
                        let value = e.target.value;

                        if (key === "customerPhone") {
                          value = value.replace(/\D/g, "");
                        }

                        setFormData({
                          ...formData,
                          [key]: value,
                        });

                        if (errors[key]) {
                          setErrors({
                            ...errors,
                            [key]: null,
                          });
                        }
                      }}
                    />
                    {errors[key] && (
                      <div className="invalid-feedback">{errors[key]}</div>
                    )}
                  </div>
                ))}

                <div className="col-md-12 form-group">
                  <label>Ghi chú</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={formData.note}
                    onChange={(e) =>
                      setFormData({ ...formData, note: e.target.value })
                    }
                  ></textarea>
                </div>
              </div>
            </div>

            {/* Chi tiết đơn hàng chuyển xuống đây */}
            <h5 className="section-title position-relative text-uppercase mb-3">
              <span className="bg-secondary pr-3">Chi tiết đơn hàng</span>
            </h5>
            <div className="mb-5">
              {products.length === 0 ? (
                <div className="bg-light p-4 rounded text-center text-muted">
                  Không có sản phẩm nào trong đơn hàng.
                </div>
              ) : (
                products.map((item, index) => (
                  <div key={index} className="cart-product-card">
                    <Link
                      to={`/san-pham/${item.slug}`}
                      aria-label={`Xem chi tiết sản phẩm ${item.name}`}
                    >
                      <img src={item.image} alt={item.name} />
                    </Link>
                    <div className="product-info">
                      <h5 title={item.name}>{item.name}</h5>
                      {item.options?.length > 0 && (
                        <div className="mb-1">
                          {item.options.map((opt, i) => (
                            <span key={i} className="option-chip">
                              <b>{opt.value}</b>
                            </span>
                          ))}
                        </div>
                      )}
                      <div className="product-price !mb-0">
                        {moneyFormat(item.price)}
                      </div>
                      {item.originalPrice && (
                        <div className="product-price !mt-0 line-through !text-gray-500 !text-sm">
                          {moneyFormat(item.originalPrice)}
                        </div>
                      )}
                      <div
                        className="mt-2 text-muted text-end"
                        style={{ fontSize: 14 }}
                      >
                        Số lượng: <b>{item.quantity}</b>
                      </div>
                      <div className="total-price mt-2">
                        Tổng tiền: {moneyFormat(item.price * item.quantity)}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Right side: Mã giảm giá (trên) -> Tổng đơn hàng -> Thanh toán */}
          <div className="col-lg-4">
            {/* Mã giảm giá chuyển lên đầu */}
            <h5 className="section-title position-relative text-uppercase mb-3">
              <span className="bg-secondary pr-3">Mã giảm giá</span>
            </h5>
            <div className="bg-light p-30 mb-4 rounded">
              <div className="mb-3">
                <h6 className="mb-3">Nhập mã giảm giá</h6>
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nhập mã giảm giá của bạn"
                    value={discountCode}
                    onChange={(e) => {
                      const value = e.target.value;
                      setDiscountCode(value);
                      if (value.length > 0) {
                        setSelectedDiscounts([
                          { code: value, description: `Mã giảm giá: ${value}` },
                        ]);
                      }
                    }}
                    disabled={isValidatingDiscount}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        const code = discountCode;
                        if (code) {
                          if (
                            selectedDiscounts.some((d) => d.code === code) ||
                            appliedDiscounts.some((d) => d.code === code)
                          ) {
                            toast.error("Mã giảm giá này đã được thêm");
                          } else {
                            setSelectedDiscounts([
                              ...selectedDiscounts,
                              { code, description: `Mã giảm giá: ${code}` },
                            ]);
                            setDiscountCode("");
                            if (selectedDiscounts.length === 0) {
                              setTimeout(() => {
                                applySelectedDiscounts();
                              }, 100);
                            }
                          }
                        } else {
                          toast.error("Vui lòng nhập mã giảm giá");
                        }
                      }
                    }}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-primary"
                      type="button"
                      disabled={isValidatingDiscount}
                      onClick={applySelectedDiscounts}
                    >
                      Áp dụng
                    </button>
                  </div>
                </div>
              </div>

              {isValidatingDiscount && !selectedDiscounts.length && (
                <div className="alert alert-warning small mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      className="spinner-border spinner-border-sm mr-2"
                      role="status"
                    >
                      <span className="sr-only">Đang kiểm tra...</span>
                    </div>
                    <span>Đang kiểm tra mã giảm giá...</span>
                  </div>
                </div>
              )}

              {appliedDiscounts.length > 0 && (
                <div className="applied-discounts mb-3">
                  <h6 className="mb-2">Mã giảm giá đã áp dụng:</h6>
                  <div>
                    {appliedDiscounts.map((discount, index) => (
                      <div
                        key={index}
                        className="badge badge-primary p-2 m-1 d-inline-flex align-items-center"
                      >
                        <span className="mr-1">{discount.code}</span>
                        <span className="small">({discount.description})</span>
                        <button
                          type="button"
                          className="btn btn-sm text-white ml-2"
                          onClick={() => removeDiscount(discount)}
                          disabled={isValidatingDiscount}
                          style={{
                            background: "none",
                            border: "none",
                            padding: "0 0 0 5px",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}

                    <div className="mt-2">
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={removeAllDiscounts}
                        disabled={isValidatingDiscount}
                      >
                        Xóa tất cả mã
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Tổng đơn hàng */}
            <h5 className="section-title position-relative text-uppercase mb-3">
              <span className="bg-secondary pr-3">Tổng đơn hàng</span>
            </h5>
            <div className="bg-light p-30 mb-5 rounded">
              <div className="border-bottom pb-2 mb-2">
                <div className="d-flex justify-content-between mb-2">
                  <span>Tạm tính</span>
                  <span>
                    {moneyFormat(orderSummary.originalTotal || totalPrice)}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span>Giảm giá</span>
                  <span className="text-danger">
                    -{moneyFormat(discountAmount)}
                  </span>
                </div>
              </div>
              <div className="pt-2">
                <div className="d-flex justify-content-between mt-2">
                  <h5>Tổng cộng</h5>
                  <h5>{moneyFormat(finalTotal)}</h5>
                </div>
              </div>
            </div>

            {/* Phương thức thanh toán */}
            <div className="mb-5">
              <h5 className="section-title position-relative text-uppercase mb-3">
                <span className="bg-secondary pr-3">
                  Phương thức thanh toán
                </span>
              </h5>
              <div className="bg-light p-30">
                {[{ id: "cod", label: "Thanh toán khi nhận hàng" }].map(
                  ({ id, label }, index) => (
                    <div key={index} className="form-group">
                      <div className="custom-control custom-radio">
                        <input
                          type="radio"
                          className="custom-control-input"
                          name="payment"
                          id={id}
                          value={id}
                          checked={formData.paymentMethod === id}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              paymentMethod: e.target.value,
                            })
                          }
                        />
                        <label className="custom-control-label" htmlFor={id}>
                          {label}
                        </label>
                      </div>
                    </div>
                  ),
                )}
                <div className="grid max-md:bg-white max-md:p-4 grid-cols-2 gap-4 fixed bottom-0 p-2 left-0 w-full z-[1024] justify-center items-center md:static md:z-0 md:grid-cols-1 md:p-0">
                  <button
                    className="btn max-md:w-3/4 max-md:mx-auto btn-block btn-primary font-weight-bold max-md:py-2 md:py-3 rounded"
                    onClick={() => navigate("/cart")}
                  >
                    Giỏ hàng
                  </button>
                  <button
                    className="btn max-md:w-3/4 max-md:mx-auto btn-block btn-success font-weight-bold max-md:py-2 md:py-3 rounded mt-0"
                    onClick={handleCheckout}
                    disabled={isSubmitting || isValidatingDiscount}
                  >
                    {isSubmitting ? "Đang xử lý..." : "Xác nhận"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showConfirmModal && <ConfirmationModal />}

      <style>{`
        .modal-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1050;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .modal-container .modal {
          z-index: 1051;
          position: relative;
          margin: 0 auto;
          background: transparent;
        }

        .cart-product-card {
          padding: 1rem;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgb(0 0 0 / 0.1);
          background-color: #fff;
          position: relative;
          display: flex;
          gap: 1.25rem;
          align-items: start;
          flex-direction: row;
          margin-bottom: 1rem;
        }
        .cart-product-card img {
          width: 120px;
          height: 80px;
          object-fit: cover;
          border-radius: 8px;
          flex-shrink: 0;
          background-color: #f9f9f9;
          border: 1px solid #eee;
        }
        .product-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-left: 0px;
        }
        .product-info h5 {
          margin: 0 1.3rem 0.3rem 0;
          font-weight: 400;
          font-size: 1.1rem;
          color: #333;
          line-height: 1.4;
          max-height: 3.6em;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .option-chip {
          display: inline-block;
          background: #eff6ff;
          border: 1px solid #3b82f6;
          color: #2563eb;
          border-radius: 999px;
          font-size: 12px;
          padding: 2px 10px;
          margin-right: 4px;
          margin-bottom: 2px;
          font-weight: 500;
        }
        .product-price {
          font-weight: 400;
          font-size: 1rem;
          color: #d9534f;
          margin: 0 0 0.5rem 0;
        }
        .line-through {
          text-decoration: line-through;
          color: #888 !important;
          font-size: 0.98em !important;
          margin-bottom: 0 !important;
        }
        .total-price {
          display: flex;
          justify-content: flex-end;
          font-weight: 600;
          font-size: 1rem;
          color: #444;
        }
      `}</style>
    </>
  );
};
